

import React, { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import ClientAuthContext from "../../context/ClientAuthContext";
import { serverInstance } from "../../service/axios";

const ClientAuthProvider = () => {

  const navigate = useNavigate();
  const {setUserData} = useContext(ClientAuthContext)
  
  useEffect(() => {
    const token = localStorage.getItem("lingoPortalToken")
    if (token) {
      serverInstance.get("/school/client", {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      })
      .then(res => {
        setUserData(res.data.user)
      })
      .catch(err => {
        console.error(err)
      })
    }
    else if (window.location.pathname.startsWith("/school/")) {
      navigate("/school/signin")
    }
  }, [])

  useEffect(() => {
    const token = localStorage.getItem("lingoPortalToken")
    if (!token && window.location.pathname.startsWith("/school/")) {
      navigate("/school/signin")
    }
  }, [window.location.pathname]);

  return <Outlet/>
};

export default ClientAuthProvider;

export const useAuth = () => {
  return useContext(ClientAuthContext);
};
